import { getImageUrl } from './imageBlobStore';

export async function getImageSize(blob: Blob): Promise<{ width: number; height: number }> {
    // Fast path
    if ('createImageBitmap' in window) {
        const bmp = await createImageBitmap(blob);
        const size = { width: bmp.width, height: bmp.height };
        bmp.close?.();
        return size;
    }
    // Fallback
    const url = URL.createObjectURL(blob);
    try {
        const img = new Image();
        img.src = url;
        await img.decode();
        return { width: img.naturalWidth, height: img.naturalHeight };
    } finally {
        URL.revokeObjectURL(url);
    }
}

export function fitWidthKeepAspect(w: number, h: number, maxW = 600, maxH = 400) {
    if (w <= maxW && h <= maxH) return { width: w, height: h };
    const scale = Math.min(maxW / w, maxH / h);
    return { width: Math.round(w * scale), height: Math.round(h * scale) };
}

export function extFromFileNameOrType(name: string, type: string): string {
    const byName = (name?.split('.').pop() || '').toLowerCase();
    if (byName) return '.' + byName;
    const t = (type || '').toLowerCase();
    if (t.includes('png')) return '.png';
    if (t.includes('jpeg') || t.includes('jpg')) return '.jpg';
    if (t.includes('gif')) return '.gif';
    if (t.includes('webp')) return '.webp';
    return '.bin';
}

export function getResolvedSrc(src: string) {
    return src.startsWith('local://')
        ? getImageUrl(src.slice('local://'.length)) ||
              'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='
        : src;
}
